export const APP_API = process.env.REACT_APP_API || '/api';
export const RC_DOMAIN = process.env.REACT_APP_RC_DOMAIN || '';
export const JITSI_DOMAIN = process.env.REACT_APP_JITSI_DOMAIN || 'http://localhost';
export const JITSI_HOSTNAME = process.env.REACT_APP_JITSI_HOSTNAME || new URL(JITSI_DOMAIN).hostname;
export const WORDPRESS_DOMAIN = process.env.REACT_APP_WORDPRESS_DOMAIN || '';
export const APP_API_WS = process.env.REACT_APP_API_WS || '';
export const ORCID_CLIENT_ID = process.env.REACT_APP_ORCID_CLIENT_ID || '';
export const ORCID_CLIENT_SECRET = process.env.REACT_APP_ORCID_CLIENT_SECRET || '';
export const ORCID_REDIRECT_URI = process.env.REACT_APP_ORCID_REDIRECT_URI || '/';